var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.product)?_c('span',{on:{"click":function($event){$event.stopPropagation();}}},[(_vm.product.id)?_c('a',{attrs:{"href":_vm.priceUrl(_vm.product.id),"target":"_blank"}},[_vm._v(_vm._s(_vm.product.name))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }